function Footer() {
    return ( 
        <footer className="h-7 w-full bg-master_color-600 text-center">
            <span className="text-white text-sm">&copy; ZaraCloud Solution v1.1.0</span>
        </footer>
    );
}

export default Footer;